import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiCallerService } from './api/api-caller.service';
import { ApiAdapterService } from './api-adapter.service';
@Injectable({
  providedIn: 'root'
})
export class TicketService {
  constructor(private http: HttpClient, private apiCaller: ApiCallerService, private apiAdapter: ApiAdapterService) { }
  
  getTicketInfo(id: string): Observable<any> {
    return this.apiAdapter.getTicketInfo(id);
  }
  postTicketInfo(param: any): Observable<any> {
    return this.apiAdapter.submitTicket(param);
  }
  getProblemSubCategory(id:number): Observable<any> {
    return this.apiAdapter.getProblemSubCategory(id);
  }

  importAttachment(id:number,param:any): Observable<any> {
    return this.apiCaller.post(
      'api/Attachment/Attachments/'+id,
      param
    );
  }

  updateTicketStatus(id:number,param:any): Observable<any> {
    return this.apiAdapter.updateTicketStatus(id, param);
  }

  getReassignTeamName(id:number): Observable<any> {
    return this.apiAdapter.getAssignedBySubCategory(id);
  }

  getAttachmentsByID(id:number): Observable<any> {
    return this.apiAdapter.getAttachmentsByID(id);
  }

  deleteFilesByID(id:number): Observable<any> {
    return this.apiCaller.delete('api/Attachment/'+ id)
    .pipe(map((response) => response));
  }

  downloadFilesByID(id:number,show?:boolean): Observable<any> {
    const httpParams = new HttpParams().set("preview",show || false)
    return this.apiCaller.getBlob('api/Attachment/'+ id,httpParams)
  }

  getTicketLogsList(param:any): Observable<any> {
    return this.apiCaller.post(
      'api/TicketLogAction/GetTicketLogActionPage',
      param
    );
  }
  cancelTicketById(id:number): Observable<any> {
    return this.apiCaller.delete('api/Ticket/'+ id)
    .pipe(map((response) => response));
  }
  //判断是否为support team
  getSupportTeam(assignToTeamID:number): Observable<any> {
    return this.apiAdapter.getSupportTeam();
  }

  getMailList(): Observable<any> {
    return this.apiAdapter.getMailList();
  }
  
  getCategoryIDByCode(categoryCode:string,subCategoryCode?:string): Observable<any> {
    return this.apiAdapter.getCategoryIDByCode(categoryCode, subCategoryCode);
  }

  getTicketRemark(param:any): Observable<any> {
    return this.apiCaller.post(
      'api/TicketRemark/GetTicketRemarkPage',
      param
    );
  }

  addRemark(param:any) :Observable<any> {
    return this.apiCaller.post(
      'api/TicketRemark/InsertTicketRemark',
      param
    );
  }
  
  getProblemCategory() {
    return this.apiAdapter.getProblemCategory();
  }

  saveTicketInfo(param: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}api/Ticket/InsertOrUpdateTicket`, param);
  }
}
